import React from 'react'
import { useTranslation } from '../../hooks/use-i18n'

export type HowIEatTabId = 'today' | 'plan' | 'stats'

interface Props {
  activeTab: HowIEatTabId
  onChange: (tab: HowIEatTabId) => void
}

const HowIEatSegmentTabs: React.FC<Props> = ({ activeTab, onChange }) => {
  const { t } = useTranslation()

  const tabs: { id: HowIEatTabId; label: string }[] = [
    { id: 'today', label: t('howIEat.tabs.today') },
    { id: 'plan', label: t('howIEat.tabs.plan') },
    { id: 'stats', label: t('howIEat.tabs.stats') },
  ]

  return (
    <div className="flex gap-2 mb-6">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`flex-1 min-w-0 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors border ${
              isActive
                ? 'bg-emerald-500/20 border-emerald-500/50 text-emerald-300'
                : 'bg-white/5 border-white/10 text-white/85 hover:bg-white/10'
            }`}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}

export default HowIEatSegmentTabs
